import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_URL, BRANCH_API } from "utilities";
import { queryClient } from "utilities/queryClient";

const authHeader = () => ({ Authorization: localStorage.getItem("token") });

export const branchKeys = {
  all: ["branch"],
  detail: () => ["branch", "detail"],
};

const fetchBranch = () =>
  axios
    .get(`${API_BASE_URL}${BRANCH_API}`, { headers: authHeader() })
    .then((r) => r.data);

/** Branch settings/profile. */
export function useBranch(options = {}) {
  return useQuery({
    queryKey: branchKeys.detail(),
    queryFn: fetchBranch,
    staleTime: 10 * 60 * 1000, // branch data is very stable
    ...options,
  });
}

/** Update branch settings. */
export function useUpdateBranch(options = {}) {
  return useMutation({
    mutationFn: (data) =>
      axios
        .patch(`${API_BASE_URL}${BRANCH_API}`, data, { headers: authHeader() })
        .then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: branchKeys.all });
    },
    ...options,
  });
}
